import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const galleryImages = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_insider_video_1.png",
  alt: "Cloud Computing Insider Video 1",
  title: "Are Hyperscalers Paying Consulting Firms to be Sales Channels?",
  channel: "Cloud Computing Insider",
  published: "2 days ago",
  duration: "14:20",
  videoLink: "https://www.youtube.com/watch?v=uTaIIJT_Wkk"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_insider_video_2.png",
  alt: "Cloud Computing Insider Video 2",
  title: "Why You Still Can't Get a Cloud Job in 2026",
  channel: "Cloud Computing Insider",
  published: "5 days ago",
  duration: "18:45",
  videoLink: "https://www.youtube.com/watch?v=J6xHzlZJLLw"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_insider_video_3.png",
  alt: "Cloud Computing Insider Video 3",
  title: "Is On-Prem DEAD? Cloud Providers Bought All the DRAM!",
  channel: "Cloud Computing Insider",
  published: "1 week ago",
  duration: "12:10",
  videoLink: "https://www.youtube.com/watch?v=nFcTbhicsuE"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_insider_video_4.png",
  alt: "Cloud Computing Insider Video 4",
  title: "Recommending Bad Tech?",
  channel: "Cloud Computing Insider",
  published: "2 weeks ago",
  duration: "15:30",
  videoLink: "https://www.youtube.com/watch?v=WPAO4qrdb0w"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_insider_video_5.png",
  alt: "Cloud Computing Insider Video 5",
  title: "Why Digital Transformation Stalls: Cloud, Culture, AI Governance, and Workforce Readiness",
  channel: "Cloud Computing Insider",
  published: "3 weeks ago",
  duration: "22:15",
  videoLink: "https://www.youtube.com/watch?v=CnTOI-DI8kw"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/dave_linthicum_not_ai_1.png",
  alt: "Dave Linthicum Is Not AI Episode 1",
  title: "Why \"AI First\" Is a Terrible Enterprise Strategy",
  channel: "Dave Linthicum Is Not AI",
  published: "1 month ago",
  duration: "45:00",
  videoLink: "https://www.youtube.com/watch?v=seKXG5cM3lA"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/dave_linthicum_not_ai_2.png",
  alt: "Dave Linthicum Is Not AI Episode 2",
  title: "The Hard Truth: Some Applications Should Never Use AI",
  channel: "Dave Linthicum Is Not AI",
  published: "1 month ago",
  duration: "38:20",
  videoLink: "https://www.youtube.com/watch?v=VxFYfbF1Hgs"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/dave_linthicum_not_ai_3.png",
  alt: "Dave Linthicum Is Not AI Episode 3",
  title: "Big Tech is Killing Agentic AI",
  channel: "Dave Linthicum Is Not AI",
  published: "2 months ago",
  duration: "42:15",
  videoLink: "https://www.youtube.com/watch?v=tnOBQ6WH3UE"
}, {
  id: 9,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/dave_linthicum_not_ai_4.png",
  alt: "Dave Linthicum Is Not AI Episode 4",
  title: "Agentic AI Explained in Just 5 Minutes",
  channel: "Dave Linthicum Is Not AI",
  published: "2 months ago",
  duration: "51:10",
  videoLink: "https://www.youtube.com/watch?v=XU__th9RZNg"
}, {
  id: 10,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/dave_linthicum_not_ai_5.png",
  alt: "Dave Linthicum Is Not AI Episode 5",
  title: "Stop Measuring AI by Data Center Growth!",
  channel: "Dave Linthicum Is Not AI",
  published: "3 months ago",
  duration: "47:30",
  videoLink: "https://www.youtube.com/watch?v=hdzmq6qfU7U"
}];
export default function Latestyoutubevideos() {
  return <section data-section-id="241114" id="latestyoutubevideos" className="bg-background text-foreground mt-12 md:mt-16 py-8 md:py-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tighter mb-4">Latest Video Insights</h2>
          <p className="text-muted-foreground font-sans max-w-2xl mx-auto">
            Deep dives into cloud architecture and AI strategy from David's Cloud Computing Insider channel.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {galleryImages.map((video, i) => <Link key={video.id} to={video.videoLink} newTab data-index={i} className="group relative overflow-hidden rounded-lg bg-card border border-primary/20 backdrop-blur-xl transition-all duration-300 hover:scale-[1.02] hover:border-primary shadow-lg block">
              <AspectRatio ratio={16 / 9}>
                <img src={video.src} data-wvc-srcset={`${video.src}-wvc-srcset`} data-wvc-sizes={`${video.src}-wvc-sizes`} alt={video.alt} className="h-full w-full object-cover grayscale hover:grayscale-0 transition-all duration-500" loading="lazy" />
                <div className="absolute bottom-2 right-2 bg-black/80 px-2 py-1 rounded-md text-[10px] font-mono text-white">
                  {video.duration}
                </div>
              </AspectRatio>
              <div className="p-4 bg-card/80 backdrop-blur-md border-t border-primary/10">
                <div className="flex justify-between items-start mb-2">
                  <span className="text-[10px] font-mono uppercase tracking-widest text-primary">
                    {video.channel}
                  </span>
                  <span className="text-[10px] font-mono text-muted-foreground">
                    {video.published}
                  </span>
                </div>
                <h3 className="text-lg font-default font-extrabold tracking-tight text-foreground group-hover:text-primary transition-colors line-clamp-2">
                  {video.title}
                </h3>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs font-mono text-muted-foreground">WATCH NOW</span>
                  <div className="h-px flex-1 mx-4 bg-gradient-to-r from-primary/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <div className="w-2 h-2 rounded-lg bg-primary animate-pulse" />
                </div>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}